import { ContentCourseItem, ContentStatus } from '../model';

export type CourseListFilters = {
  search: string;
  status: ContentStatus | 'all';
};

export const DEFAULT_COURSE_LIST_FILTERS: CourseListFilters = {
  search: '',
  status: 'all',
};

export const filterCourses = (courses: ContentCourseItem[], filters: CourseListFilters) => {
  const search = filters.search.trim().toLowerCase();

  return courses.filter((course) => {
    if (filters.status !== 'all' && course.status !== filters.status) {
      return false;
    }

    if (search) {
      const haystack = [course.name, course.description || '', course.audience || '']
        .join(' ')
        .toLowerCase();

      if (!haystack.includes(search)) {
        return false;
      }
    }

    return true;
  });
};
